// utils/debounce.ts

/**
 * Debounces the execution of the provided function.
 *
 * @param {() => void} func - The function to debounce.
 * @param {number} delay - The delay in milliseconds for debounce.
 * @returns {() => void} The debounced function.
 */
export function debounce(func: () => void, delay: number): () => void {
	let timeoutId: number | undefined;

	return () => {
		if (timeoutId !== undefined) {
			clearTimeout(timeoutId);
		}
		timeoutId = window.setTimeout(() => {
			func();
			timeoutId = undefined;
		}, delay);
	};
}
